const TREE_SPECIES_OPTIONS = [
    { label: 'Abete bianco', value: 'abete_bianco' },
    { label: 'Abete rosso', value: 'abete_rosso' },
    { label: 'Abete di Douglas', value: 'abete_di_douglas' },
    { label: 'Larice europeo', value: 'larice_europeo' },
    { label: 'Pino domestico', value: 'pino_domestico' },
    { label: 'Pino marittimo', value: 'pino_marittimo' },
    { label: 'Pino d\'Aleppo', value: 'pino_d_aleppo' },
    { label: 'Pino silvestre', value: 'pino_silvestre' },
    { label: 'Pino nero', value: 'pino_nero' },
    { label: 'Pino mugo', value: 'pino_mugo' },
    { label: 'Pino cembro', value: 'pino_cembro' },
    { label: 'Cedro dell\'Atlante', value: 'cedro_dell_atlante' },
    { label: 'Cedro dell\'Himalaya', value: 'cedro_dell_himalaya' },
    { label: 'Cipresso comune', value: 'cipresso_comune' },
    { label: 'Tasso', value: 'tasso' },
    { label: 'Ginepro', value: 'ginepro' },
    { label: 'Leccio', value: 'leccio' },
    { label: 'Rovere', value: 'rovere' },
    { label: 'Roverella', value: 'roverella' },
    { label: 'Farnia', value: 'farnia' },
    { label: 'Cerro', value: 'cerro' },
    { label: 'Sughera', value: 'sughera' },
    { label: 'Faggio', value: 'faggio' },
    { label: 'Castagno', value: 'castagno' },
    { label: 'Carpino bianco', value: 'carpino_bianco' },
    { label: 'Carpino nero', value: 'carpino_nero' },
    { label: 'Betulla bianca', value: 'betulla_bianca' },
    { label: 'Ontano nero', value: 'ontano_nero' },
    { label: 'Ontano bianco', value: 'ontano_bianco' },
    { label: 'Frassino maggiore', value: 'frassino_maggiore' },
    { label: 'Orniello', value: 'orniello' },
    { label: 'Acero campestre', value: 'acero_campestre' },
    { label: 'Acero di monte', value: 'acero_di_monte' },
    { label: 'Acero opalo', value: 'acero_opalo' },
    { label: 'Tiglio selvatico', value: 'tiglio_selvatico' },
    { label: 'Tiglio nostrano', value: 'tiglio_nostrano' },
    { label: 'Olmo campestre', value: 'olmo_campestre' },
    { label: 'Nocciòlo', value: 'nocciolo' },
    { label: 'Sorbo domestico', value: 'sorbo_domestico' },
    { label: 'Sorbo torminale', value: 'sorbo_torminale' },
    { label: 'Melo selvatico', value: 'melo_selvatico' },
    { label: 'Pero selvatico', value: 'pero_selvatico' },
    { label: 'Ciliegio selvatico', value: 'ciliegio_selvatico' },
    { label: 'Pruno padano', value: 'pruno_padano' },
    { label: 'Pioppo bianco', value: 'pioppo_bianco' },
    { label: 'Pioppo nero', value: 'pioppo_nero' },
    { label: 'Pioppo tremulo', value: 'pioppo_tremulo' },
    { label: 'Robinia', value: 'robinia' },
    { label: 'Albero di Giuda', value: 'albero_di_giuda' },
    { label: 'Maggiociondolo', value: 'maggiociondolo' },
    { label: 'Corbezzolo', value: 'corbezzolo' },
    { label: 'Ligustro', value: 'ligustro' },
    { label: 'Agrifoglio', value: 'agrifoglio' },
    { label: 'Eucalipto', value: 'eucalipto' },
    { label: 'Olivo', value: 'olivo' },
    { label: 'Platano comune', value: 'platano_comune' },
    { label: 'Albicocco', value: 'albicocco' },
    { label: 'Mandorlo', value: 'mandorlo' },
    { label: 'Noce comune', value: 'noce_comune' },
    { label: 'Gelso bianco', value: 'gelso_bianco' },
    { label: 'Gelso nero', value: 'gelso_nero' },
    { label: 'Ginkgo', value: 'ginkgo' },
    { label: 'Paulonia', value: 'paulonia' },
    { label: 'Catalpa', value: 'catalpa' },
    { label: 'Ficus', value: 'ficus' },
    { label: 'Tamerice', value: 'tamerice' }
  ];
  
  export default TREE_SPECIES_OPTIONS;